import { templateHireflixDeleteVideoInterviewRoute } from '@features/enterprise/api/constants';
import { errorMessage } from '@features/positions';
import axiosInstance from '@server/axiosInstance';
import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import { templateList } from '../constants';

type useHireflixDeleteVideoInterviewProps = {
  setErrorText?: Dispatch<SetStateAction<string>>;
};

export const useHireflixDeleteVideoInterview = ({
  setErrorText = () => {},
}: useHireflixDeleteVideoInterviewProps) => {
  const client = useQueryClient();

  const {
    mutate: deleteVideoInterview,
    isLoading: isDeleteVideoInterviewLoading,
  } = useMutation({
    mutationFn: (variables: { job_id: number; template_id: number }) =>
      axiosInstance
        .post(templateHireflixDeleteVideoInterviewRoute, variables)
        .then((res) => res.data),
    onSuccess: (data) => {
      if (data.status !== 200) {
        setErrorText(data.message);
      } else {
        client.invalidateQueries([templateList]);
        setErrorText('');
      }
    },
    onError: () => {
      setErrorText(errorMessage);
    },
  });

  return { deleteVideoInterview, isDeleteVideoInterviewLoading };
};
